import {ISessionState, Region} from "src/context/models/Session";

export default {
    data: {
        region: Region.NA
    }
} as ISessionState;
